import appConfig from "@/config";
import { WisWizAPI } from "@/services/api";
import { Dispatch, SetStateAction, useCallback } from "react";

type useShareLinkProps = {
  api: WisWizAPI;
  setShareLink: Dispatch<SetStateAction<string | undefined>>;
};

function getShareLinkOrigin() {
  if (appConfig.environment === "production") return "https://wiswiz.nl";
  if (appConfig.environment === "staging") return "https://staging.wiswiz.nl";

  return window.location.origin;
}

export function useShareLink({ api, setShareLink }: useShareLinkProps) {
  const cb = useCallback(
    async (vraagId: number) => {
      const res = await api.shareVraag(vraagId);

      if (res) {
        const token = res.token;
        const origin = getShareLinkOrigin();
        const fullUrl = `${origin}/library/vraag/${vraagId}?share=${token}`;

        setShareLink(fullUrl);
      }
    },
    [api, setShareLink]
  );

  return cb;
}
